var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-add-page"},[_c('pageTitle',{attrs:{"pageTitle":_vm.$route.query.cardId ? _vm.$t('lang.k_333001') : _vm.$t('lang.k_333002')}}),_c('PushCardCreate',{attrs:{"env":_vm.env,"cardId":_vm.cardId,"webinarId":_vm.$route.query.webinarId,"scene":_vm.scene},on:{"saveSuccess":_vm.saveSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }